<ng-template #popHeader>
  <i class="material-icons">warning</i>
  <i class="material-icons">warning</i>
  <h6>{{title | translate}}</h6>
</ng-template>
<ng-template #popContent>{{text | translate}}</ng-template>
<i class="material-icons" placement="{{placement}}" [ngbPopover]="popContent" [popoverTitle]="popHeader">warning</i>
